import { render } from "./DisciplineSelect.vue?vue&type=template&id=20f0a3ce"
import script from "./DisciplineSelect.vue?vue&type=script&lang=js"
export * from "./DisciplineSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__